<a *ngIf="showContactPageLink" class="contact-img" (click)="showPage('/support/kontakt-os')">
    <div class="contact-img-text">
        <h5>Flere spørgsmål?</h5>
        <p>Skriv til vores kundeservice her</p>
    </div>
</a>
<div class="opening-hours mt-3 mb-3">
    <ul class="list-group">
        <li class="list-group-item list-group-item-title">
            <span>Åbningstider kundeservice:</span>
        </li>
        <li class="list-group-item opening-hours-Monday" [class.list-group-item-light]="currentDay === 'Monday'">
            <span class="opening-hours-day float-start">Mandag</span>
            <span class="opening-hours-time float-end">09:00 - 18:00</span>
        </li>
        <li class="list-group-item opening-hours-Tuesday" [class.list-group-item-light]="currentDay === 'Tuesday'">
            <span class="opening-hours-day float-start">Tirsdag</span>
            <span class="opening-hours-time float-end">09:00 - 18:00</span>
        </li>
        <li class="list-group-item opening-hours-Wednesday" [class.list-group-item-light]="currentDay === 'Wednesday'">
            <span class="opening-hours-day float-start">Onsdag</span>
            <span class="opening-hours-time float-end">09:00 - 18:00</span>
        </li>
        <li class="list-group-item opening-hours-Thursday" [class.list-group-item-light]="currentDay === 'Thursday'">
            <span class="opening-hours-day float-start">Torsdag</span>
            <span class="opening-hours-time float-end">09:00 - 18:00</span>
        </li>
        <li class="list-group-item opening-hours-Friday" [class.list-group-item-light]="currentDay === 'Friday'">
            <span class="opening-hours-day float-start">Fredag</span>
            <span class="opening-hours-time float-end">09:00 - 18:00</span>
        </li>
        <li class="list-group-item" [class.list-group-item-light]="currentDay === 'Saturday' || currentDay === 'Sunday'">
            <span class="opening-hours-day float-start">Lørdag-Søndag</span>
            <span class="opening-hours-time float-end">Lukket</span>
        </li>
        <li class="list-group-item list-group-item-phone">

            <a href="tel:33420900">
                <span class="phone-icon"></span>
                <span>3342 0900</span>
            </a>
        </li>
        <li class="list-group-item list-group-item-text">
            <p>
                <strong>Vær opmærksom på:</strong> Vi holder lukket alle helligdage, samt påske, pinse og
                Kristi himmelfartsdag.<br>
                Mellem jul og nytår har telefonerne åbent fra den 27. til og med den 30. december 2021 fra
                kl. 10.00 til 16.00.
            </p>
        </li>
    </ul>
</div>